module.exports = __webpack_public_path__ + "static/media/5.ab97b186.jpg";